import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-10-12
 */

import buildURL from 'axios/lib/helpers/buildURL';

export default function buildSortedURL() {

	var builtURL = buildURL.apply(undefined, arguments);

	var _builtURL$split = builtURL.split('?'),
	    _builtURL$split2 = _slicedToArray(_builtURL$split, 2),
	    urlPath = _builtURL$split2[0],
	    queryString = _builtURL$split2[1];

	if (queryString) {
		var paramsPair = queryString.split('&');
		return urlPath + '?' + paramsPair.sort().join('&');
	}

	return builtURL;
}


//////////////////
// WEBPACK FOOTER
// ./~/axios-extensions/esm/utils/buildSortedURL.js
// module id = XVc3
// module chunks = 2